module.exports = __webpack_public_path__ + "img/buddy_eyes-06.73c867e9.svg";